import React from "react";

export const PageHeader = ({ step, total = 3, title, subtitle }) => {
  return (
    <div className="mb-8 animate-fade-slide-up">
      <span
        data-testid="step-pill"
        className="inline-flex items-center px-3 py-1 rounded-full border border-white/10 bg-white/5 text-xs font-medium uppercase tracking-[0.2em] text-zinc-400 mb-4"
      >
        Step {step} of {total}
      </span>
      <h1
        data-testid="page-title"
        className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-white"
      >
        {title}
      </h1>
      {subtitle && (
        <p data-testid="page-subtitle" className="mt-3 font-body text-base text-zinc-400 leading-relaxed max-w-xl">
          {subtitle}
        </p>
      )}
    </div>
  );
};
